import React, { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { Card } from './UI';

const ActivityChecklistItem = ({ activity, isDone, onToggle }) => (
    <div onClick={() => onToggle(activity.id, !isDone)} className="flex items-start space-x-3 p-3 bg-white rounded-lg cursor-pointer border hover:border-sky-500">
        <div className={`mt-1 flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center ${isDone ? 'bg-brand-purple border-brand-purple' : 'border-gray-300'}`}>
            {isDone && <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>}
        </div>
        <p className={`text-brand-dark ${isDone ? 'line-through text-gray-400' : ''}`}>{activity.text}</p>
    </div>
);

export default function InterventionPlanCard({ user, child, plan }) {
    const [progress, setProgress] = useState(plan.progress || {});

    const handleToggle = async (activityId, isDone) => {
        const newProgress = { ...progress, [activityId]: isDone };
        setProgress(newProgress); // Optimistic update

        try {
            const planRef = doc(db, `children/${child.id}/interventionPlans/${plan.id}`);
            await updateDoc(planRef, { progress: newProgress });
        } catch (error) {
            console.error("Error updating plan progress:", error);
        }
    };

    const percentage = Math.round((Object.values(progress).filter(Boolean).length / plan.activities.length) * 100) || 0;

    return (
        <Card className="bg-yellow-50 border-yellow-300">
            <h3 className="text-xl font-bold text-yellow-800 mb-2">{plan.title}</h3>
            <p className="text-sm text-yellow-700 mb-4">{plan.description}</p>
            
            {plan.notes && (
                <div className="p-3 bg-white rounded-lg mb-4 border border-yellow-200">
                    <p className="text-sm font-bold text-brand-dark">Catatan dari Tenaga Kesehatan:</p>
                    <p className="text-sm text-brand-muted italic">"{plan.notes}"</p>
                </div>
            )}

            <div className="mb-4">
                <div className="flex justify-between mb-1"><span className="text-sm font-medium text-yellow-700">Progres</span><span className="text-sm font-medium text-yellow-800">{percentage}%</span></div>
                <div className="w-full bg-yellow-200 rounded-full h-2.5"><div className="bg-yellow-500 h-2.5 rounded-full" style={{ width: `${percentage}%` }}></div></div>
            </div>

            <div className="space-y-3">
                {plan.activities.map(activity => (
                    <ActivityChecklistItem 
                        key={activity.id}
                        activity={activity}
                        isDone={!!progress[activity.id]}
                        onToggle={handleToggle}
                    />
                ))}
            </div>
        </Card>
    );
}
